import { render, staticRenderFns } from "./corteCaja.vue?vue&type=template&id=664bb6bb"
import script from "./corteCaja.vue?vue&type=script&lang=js"
export * from "./corteCaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports